<template>
  <st-modal class="st-forgot-password-modal" @esc-close="close" v-if="open">
    <template v-slot:header>
      <div class="st-forgot-password-modal__header st-modal-header">
        <h3>Glömt lösenordet?</h3>
        <span class="st-forgot-password-modal__header__desc"
          >Välj att få nytt lösenord via mejl eller sms. OBS Har du redan
          efterfrågat ett nytt lösenord men inte fått något? Vänta 15 minuter
          innan du försöker igen.</span
        >
        <st-error
          v-if="hasError"
          :error="error"
          :errorMessage="error.message"
          :unhandled-error-message="error.unhandledErrorMessage"
        />
      </div>
    </template>

    <template v-slot:body>
      <div class="st-forgot-password-modal__body st-modal-body">
        <st-form-group
          id="forgot-password-email"
          label="Mejladress"
          required
          :validation="$v.email"
          :validation-errors="validationErrors.email"
        >
          <st-input
            tabindex="0"
            type="text"
            id="forgot-password-email"
            v-model="email"
            @keydown.tab.native="onTabShiftBack($event, true)"
            :keydown-enter="submit"
            :placeholder="'Ange din mejladress'"
            required
            :blur="$v.email.$touch"
            :invalid="$v.email.$error"
            autocomplete="on"
          />
        </st-form-group>
        <div class="st-forgot-password-modal__body__reset-type">
          <st-form-group label="Hur vill du ha din verifieringskod?" required>
            <div class="st-forgot-password-modal__body__reset-type__radios">
              <st-radio-button :value="'email'" v-model="resetType" tabindex="0"
                >Mejl</st-radio-button
              >
              <st-radio-button :value="'sms'" v-model="resetType" tabindex="0"
                >Sms</st-radio-button
              >
            </div>
          </st-form-group>
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <div class="st-forgot-password-modal__footer">
        <div class="st-forgot-password-modal__footer__actions">
          <st-button :id="'cancel'" @click="close" tabindex="0"
            >Avbryt</st-button
          >

          <st-button
            :id="'submit'"
            :primary="true"
            @click="submit"
            tabindex="0"
            @keydown.tab.native="onTabForward($event, true)"
            :disabled="disableResetPasswordButton"
            >Skicka</st-button
          >
        </div>
      </div>
    </template>
  </st-modal>
</template>

<script>
import {
  StButton,
  StFormGroup,
  StInput,
  StModal,
  StError,
  StRadioButton,
} from "skanetrafiken/dist/legacy";
import Services from "../services";
import ForgotPasswordValidations from "../validators/forgot-password-validations";
import ForgotPasswordValidationErrors from "../validators/forgot-password-validation-errors";
import {
  shiftTabToLastElement,
  tabToFirstElement,
} from "@/modules/login-form/helpers/modalTabHelper";
export default {
  name: "st-forgot-password-modal",
  props: {
    close: {
      type: Function,
    },
    open: {
      type: Boolean,
    },
    success: {
      type: Function,
    },
  },
  components: {
    StButton,
    StModal,
    StFormGroup,
    StInput,
    StError,
    StRadioButton,
  },
  data() {
    return {
      email: "",
      error: {
        message: "Något gick snett, var god försök igen senare.",
        unhandledErrorMessage: "Något gick snett, var god försök igen senare.",
      },
      resetType: "email",
      emailRef: null,
      disableResetPasswordButton: false,
      hasError: false,
      validationErrors: ForgotPasswordValidationErrors,
    };
  },
  mounted() {
    this.listenToEmailChange();
  },
  validations: {
    ...ForgotPasswordValidations,
  },
  methods: {
    listenToEmailChange() {
      this.$root.$on("email-value-updated", (email) => {
        this.email = email;
      });
    },
    submit() {
      this.disableResetPasswordButton = true;
      this.hasError = false;

      if (this.$v.$invalid) {
        document.querySelector("#forgot-password-email").focus();
        this.disableResetPasswordButton = false;
        return;
      }
      const payload = {
        email: this.email,
        resetPasswordMedia: this.resetType === "email" ? 0 : 1, // email is 0, sms is 1
      };
      Services.User.POST.REQUEST_RESET_PASSWORD(payload)
        .then(() => {
          this.success(this.resetType);
          this.close();
        })
        .catch((err) => {
          console.error(err);
          this.hasError = true;
        })
        .finally(() => {
          this.disableResetPasswordButton = false;
        });
    },
    onTabShiftBack(e, shiftToLast) {
      if (shiftToLast) shiftTabToLastElement(e, "submit");
    },
    onTabForward(e, shiftToFirst) {
      if (shiftToFirst) tabToFirstElement(e, "email");
    },
  },
  watch: {
    open(val) {
      if (val) this.listenToEmailChange();
      else this.email = ""; // resetting email when modal is closed.
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~skanetrafiken/dist/scss/main.scss";

.st-forgot-password-modal {
  font-family: $source-sans-pro;
  color: $dark-grey;
  &__header {
    &__desc {
      display: flex;
      margin-top: rem-calc(20);
    }
  }
  &__body {
    &__reset-type {
      &__radios {
        display: flex;
        margin-top: rem-calc(8);
        & > *:first-child {
          margin-right: rem-calc(8);
        }
      }
    }
  }
  &__footer {
    margin-top: rem-calc(20);
    &__actions {
      display: flex;
      flex: 1;
      & > .st-button {
        &:first-child {
          margin-right: rem-calc(8);
        }
        flex: 1;
      }
    }
  }
}
</style>
